import api from './api'

/**
 * 管理端数据迁移 / 批量导入（需平台管理员或管理员角色）
 */
export const adminDataMigrationService = {
  /**
   * 下载历史学员导入 Excel 空模板
   */
  async downloadStudentHistoryTemplate() {
    const res = await api.get('/admin/students/import-history/template', {
      responseType: 'blob',
      timeout: 60000
    })
    const blob = res.data
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'student_history_import_template.xlsx'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  },

  /**
   * 上传历史学员 Excel
   * @param {File} file
   */
  async importStudentHistory(file) {
    const formData = new FormData()
    formData.append('file', file)
    return api.post('/admin/students/import-history', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000
    })
  }
}
